module.exports = __webpack_public_path__ + "img/info.b62ed0c7.svg";